import { css } from '@/styled-system/css';

// The backdrop is a full-viewport overlay even with the scrim off, so it must not catch clicks —
// the messaging window beside the drawer stays usable. blockSize auto lets the inline `top`
// offset (below the IA top bar) and FloatingOverlay's `bottom: 0` size it.
export const drawerBackdropStyles = css.raw({
  pointerEvents: 'none',
  paddingInlineStart: 0,
  blockSize: 'auto',
});

// Width must match DRAWER_WIDTH in ../RenterMessagingModal. `lg` (768px), not `md` (480px) — and
// `md: 'none'` is load-bearing: Constellation's right-placement recipe caps the drawer at 375px from
// `md` up, and Panda merges a css prop per breakpoint, so without it that cap survives in 480-767px
// and the footer actions wrap.
export const drawerContentStyles = css.raw({
  pointerEvents: 'auto',
  maxInlineSize: { base: 'none', md: 'none', lg: '720px' },
});

// The body content carries its own bottom spacing; Constellation's default would add a second gap.
export const drawerBodyStyles = css.raw({
  paddingBlockEnd: 0,
});
